import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Ionicons } from "@expo/vector-icons"

// import Login from './pages/Login';
import Home from './pages/Home';
import Esqueci from './pages/Esqueci';
import Relatorios from './pages/Relatorios';
import Perfil from './pages/Perfil';
import Catalogo from './pages/Catalogo';
import Camera from './pages/Camera/camera';
import Compressor from './pages/Compressor';
import CompPreIndex from './pages/Compressor/preIndex';
import CompPreIndexType from './pages/Compressor/preIndexType';
import ChecklistCompressor from './pages/Compressor/checklist';
import ChecklistPitStop from './pages/PitStop/checklist';
import ChecklistRack from './pages/Rack/checklist';
import PitStop from './pages/PitStop';
import PitPreIndex from './pages/PitStop/preIndex';
import Rack from './pages/Rack';
import RackPreIndex from './pages/Rack/preIndex';
import Avaliar from './pages/Compressor/avaliar';
import AvaliarPit from './pages/PitStop/avaliar';
import AvaliarRack from './pages/Rack/avaliar';
import Despesa from './pages/Despesas/despesa';
import DespesaItem from './pages/Despesas/item';
import DespesasIndex from './pages/Despesas/index';
import DespesasIndexPending from './pages/Despesas/indexPending';
import DespesasIndexHistory from './pages/Despesas/indexHistory';
import DespesasPreIndex from './pages/Despesas/preIndex';
import DespesasCamera from './pages/Despesas/camera';
import DespesasImagem from './pages/Despesas/imagem';
import { Login } from './pages/Login';


const AppHomeStack = createStackNavigator();
// const AppRelStack = createStackNavigator();
// const AppPerfilStack = createStackNavigator();
const appTabStack = createBottomTabNavigator();

function AppScreen() {
  return (
    <appTabStack.Navigator
      screenOptions={({ route }) => ({
        tabBarLabelStyle: { fontSize: 11, fontWeight: "600" },

        "tabBarActiveTintColor": "#003c84",
        "tabBarInactiveTintColor": "#63758c",
        "tabBarStyle": [
          {
            "display": "flex", height: 72, paddingTop: 8, paddingBottom: 12, backgroundColor: "#fff", borderTopColor: "#e1e8f2"
          },
          null
        ],
        tabBarIcon: ({ focused, color, size }) => {
          let iconName;

          if (route.name === 'Home') {
            iconName = focused
              ? 'home'
              : 'home';
          } else if (route.name === 'Meus Check-Lists') {
            iconName = focused ? 'document' : 'document';
          } else {
            (iconName = focused ? 'person' : 'person')
          }

          return <Ionicons name={iconName} size={size} color={color} />;
        },
      })}

    >
      <appTabStack.Screen name="Home" component={Home}
        options={{
          title: 'Início',
          headerShown: false,
          headerLeft: null,
          headerStyle: { backgroundColor: '#003c84', height: 0 },
          headerTintColor: '#fff',
          headerTitleStyle: { fontWeight: 'bold', }
        }} />

      <appTabStack.Screen name="Meus Check-Lists" component={Relatorios}
        options={{
          title: 'Meus Check-Lists',
          headerLeft: null,
          headerStyle: { backgroundColor: '#003c84' },
          headerTintColor: '#fff',
          headerTitleStyle: { fontWeight: 'bold', }
        }} />

      <appTabStack.Screen name="Meu Perfil" component={Perfil}
        options={{
          title: 'Meu Perfil',
          headerLeft: null,
          headerStyle: { backgroundColor: '#003c84' },
          headerTintColor: '#fff',
          headerTitleStyle: { fontWeight: 'bold', }
        }} />
    </appTabStack.Navigator>
  );
};

// function RelScreen(){
//   return(
//     <AppRelStack.Navigator> 
//       <AppRelStack.Screen name="Relatorios" component={Relatorios}
//         options={{ 

//           title: 'Meus Check-Lists',
//           headerLeft: null,
//           headerStyle: { backgroundColor: '#003c84'},
//           headerTintColor: '#fff',
//           headerTitleStyle: {fontWeight: 'bold',} }}
//       />
//     </AppRelStack.Navigator>
//   );
// };

// function PerfilScreen() {
//   return (
//     <AppHomeStack.Navigator>
//       <AppPerfilStack.Screen name="Meu Perfil" component={Perfil}
//         options={{
//           title: 'Meu Perfil',
//           headerLeft: null,
//           headerStyle: { backgroundColor: '#003c84' },
//           headerTintColor: '#fff',
//           headerTitleStyle: { fontWeight: 'bold', }
//         }}
//       />
//     </AppHomeStack.Navigator>
//   );
// };



export default function Routes() {
  return (
    <NavigationContainer>

      <AppHomeStack.Navigator initialRouteName='Login' screenOptions={{ cardStyle: { backgroundColor: '#f4f7fb' }, headerTitleStyle: { fontWeight: '700', fontSize: 17 }, headerShadowVisible: false }}>
        <AppHomeStack.Screen name="Login" options={{ headerShown: false }} component={Login} />
        <AppHomeStack.Screen name="Esqueci" options={{ headerShown: false }} component={Esqueci} />
        <AppHomeStack.Screen name="Home" options={{ headerShown: false }} component={AppScreen} />
        <AppHomeStack.Screen name="Camera" options={{ headerShown: false }} component={Camera} />
        <AppHomeStack.Screen
          name="Compressor"
          component={Compressor}
          options={{
            title: 'Compressores',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen
          name="CompPreIndexType"
          component={CompPreIndexType}
          options={{
            title: 'Tipo Checklist',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen
          name="CompPreIndex"
          component={CompPreIndex}
          options={{
            title: 'Dashboard Compressor',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen
          name="PitPreIndex"
          component={PitPreIndex}
          options={{
            title: 'Dashboard Pit-Stop',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen
          name="RackPreIndex"
          component={RackPreIndex}
          options={{
            title: 'Dashboard Rack',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="ChecklistCompressor" component={ChecklistCompressor}
          options={{
            title: 'Checklist',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="PitStop" component={PitStop}
          options={{
            title: 'Pit-Stops',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="Rack" component={Rack}
          options={{
            title: 'Racks',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="ChecklistPitStop" component={ChecklistPitStop}
          options={{
            title: 'Checklist',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="ChecklistRack" component={ChecklistRack}
          options={{
            title: 'Checklist',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />

        <AppHomeStack.Screen name="Avaliar" component={Avaliar}
          options={{
            title: 'Avaliar Item',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />

        <AppHomeStack.Screen name="AvaliarPit" component={AvaliarPit}
          options={{
            title: 'Avaliar Item',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="AvaliarRack" component={AvaliarRack}
          options={{
            title: 'Avaliar Item',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="Catalogo" component={Catalogo}
          options={{
            title: 'Catalogos',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="Despesa" component={Despesa}
          options={{
            title: 'Relatório Despesa',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="DespesaItem" component={DespesaItem}
          options={{
            title: 'Item Despesa',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="DespesasIndex" component={DespesasIndex}
          options={{
            title: 'Relatório Despesas',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="DespesasIndexPending" component={DespesasIndexPending}
          options={{
            title: 'Relatório Despesas',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="DespesasIndexHistory" component={DespesasIndexHistory}
          options={{
            title: 'Relatório Despesas',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="DespesasPreIndex" component={DespesasPreIndex}
          options={{
            title: 'Relatório Despesas',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="DespesasImagem" component={DespesasImagem}
          options={{
            title: 'Foto',
            headerStyle: { backgroundColor: '#003c84' },
            headerTintColor: '#fff',
            headerTitleStyle: { fontWeight: 'bold', }
          }}
        />
        <AppHomeStack.Screen name="DespesasCamera" options={{ headerShown: false }} component={DespesasCamera} />
      </AppHomeStack.Navigator>



    </NavigationContainer>
  );
}

